<template>
  <div>
    <ContentWrapper :setBackground="{type: 'bgcolor', value: '#eaeff2'}">
      <div class="flex flex-wrap flex-col-reverse sm:flex-row max-w-1366 m-auto">
        <div class="relative sm:w-2/5">
          <img
            class="sm:absolute w-2/3 sm:w-4/5 3xl:w-full mt-4 sm:mt-0 m-auto bottom-0 right-0 transform sm:translate-y-1/3"
            src="../assets/images/article-img.png"
            alt=""
          />
        </div>
        <article class="sm:w-3/5 px-1/20">
          <h2 class="font-bold text-center sm:text-left text-2xl xl:text-3xl mb-4">關於2021<br>台灣21縣市永續城市調查</h2>
          <p class="mb-4">《今周刊》率先以聯合國發布的十七項SDGs永續目標，作為縣市評比基礎。除此之外，也納入民眾對該縣市永續表現的滿意度。</p>
          <p class="mb-4">我們將評選出「永續城市特優獎」、「永續城市優等獎」、「社會力特別傑出獎」、「經濟力特別傑出獎」、「環境力特別傑出獎」，以及針對首長施政信心度的「最佳首長信任獎」。</p>
          <p class="mb-4">另外，針對民眾對於各縣市防疫作為的滿意度，《今周刊》也會頒發2021年的「最佳防疫表現獎」。</p>
          <p>敬請期待！</p>
        </article>
      </div>
    </ContentWrapper>
    <ContentWrapper class="bg-full md:bg-auto bg-bottom" :setBackground="{type: 'infinityX', value: bgimg}">
      <div class="container w-11/12 m-auto text-center">
        <h2 class="font-bold text-2xl xl:text-3xl mb-6 tracking-normal sm:tracking-wider">2021年，台灣最強城市即將出爐</h2>
        <div class="max-w-1366 mx-auto">
          <p class="w-full xl:w-4/5 mb-6 mx-auto">在2021年世界疫後奮起變革之際，《今周刊》以「ESG 永續台灣」做為起點與號召，與城市首長攜手同行，讓SDGs不只是目標，而是地方政府如何落實永續未來最該重視的議題，一同引領台灣邁向2030永續願景。</p>
          <div class="relative pb-mediabox">
            <iframe
              src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FBToday%2Fvideos%2F907909259824419%2F&show_text=false&width=560&t=0"
              scrolling="no"
              frameborder="0"
              allowfullscreen="true"
              class="absolute w-full h-full top-0 left-0 border-0 overflow-hidden"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />
            <!-- <YoutubePlayer
              videoId="GhKymJXeN28"
              active="GhKymJXeN28"
              v-on:setActiveVideo="setActiveVideo"
              class="absolute w-full h-full top-0 left-0"
            /> -->
          </div>
        </div>
      </div>
    </ContentWrapper>
  </div>
</template>

<script>
import ContentWrapper from './models/ContentWrapper'
// import YoutubePlayer from './YoutubePlayer'

import bgimg from '../assets/images/article-bg.png'

export default {
  name: 'About',
  components: {
    ContentWrapper,
    // YoutubePlayer
  },
  data() {
    return {
      // activeVideo: '', // 當前播放中的影片ID
      bgimg: bgimg
    }
  },
  // methods: {
  //   setActiveVideo(id) {
  //     this.activeVideo = id;
  //   }
  // }
}
</script>
